<template>
    <span>
        <el-popover placement="bottom-start"
										trigger="click" min-width="500" v-if="fileList.length > 0" v-model="visible">
            <el-table :data="fileList" fit>
                <el-table-column property="name" label="名称" width="280">
                    <template slot-scope="scope">
                        <div class="text-link">{{ "原名：" + scope.row.name }}</div>
												<div class="text-link">{{ "重命名：" + scope.row.new_name }}</div>
                    </template>
                </el-table-column>
                <el-table-column property="name" label="文件大小">
                    <template slot-scope="scope">
                        <span>{{ scope.row.size | formatSize }}</span>
                    </template>
                </el-table-column>
                <el-table-column property="operation" label="操作" width="90">
                    <template slot-scope="scope">
                        <el-button size="mini"
																	 type="text"
																	 @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span class="text-link" slot="reference">{{ attachmentName }}</span>
        </el-popover>
    </span>
</template>

<script>
	import {formatSize} from "@/utils/misc";

	export default {
		name: "uploading-list",
		props: {

			fileList: {
				type: Array,
				required: true
			},
			attachmentName: {
				type: String,
				required: true
			}
		},
		filters: {
			formatSize
		},
		data() {
			return {
				visible: false
			}
		},
		methods: {
			handleDelete(file) {
				let index = this.fileList.indexOf(file);
				this.fileList.splice(index, 1);
				this.$emit("update:fileList", this.fileList);
			}
		}
	};
</script>

<style scoped>
</style>
